import { Link } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="max-w-md w-full p-10 text-center border-border" data-testid="payment-cancel-card">
        <XCircle className="h-14 w-14 mx-auto text-muted-foreground mb-4" />
        <h1 className="font-heading text-3xl font-bold tracking-tight">Payment cancelled</h1>
        <p className="text-muted-foreground mt-2">No charge was made. You can pay the invoice anytime.</p>
        <Link to="/dashboard"><Button className="rounded-full mt-6 hover:bg-primary/90" data-testid="cancel-back-button">Back to Dashboard</Button></Link>
      </Card>
    </div>
  );
}
